module.exports = __webpack_public_path__ + "img/tip.3591402c.png";